import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'td-wb-horizontal-toolbar',
  templateUrl: 'horizontal-toolbar.component.html',
  styleUrls: ['horizontal-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HorizontalToolbarComponent {
  @Input() position: 'left' | 'center' | 'right' = 'right';

  @HostBinding('class.td-wb-horizontal-toolbar--left')
  get toolbarLeft(): boolean {
    return this.position === 'left';
  }

  @HostBinding('class.td-wb-horizontal-toolbar--center')
  get toolbarCenter(): boolean {
    return this.position === 'center';
  }

  constructor() {
  }
}
